import React, { useState, useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '~/components/InputLabel';
import StyledTextField from '~/styles/components/StyledTextField';

import { Container } from './styles';

const StyledAutocomplete = withStyles({
  clearIndicator: {
    color: '#C2C2C2',
  },
  popupIndicator: {
    color: '#C2C2C2',
  },
})(Autocomplete);

function AutocompleteComponent({
  data,
  label,
  name,
  state,
  setState,
  getOptionLabel,
  ...rest
}) {
  const [value, setValue] = useState(state);

  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      clearValue: (ref) => {
        ref.value = '';
        setValue(null);
      },
    });
  }, [fieldName, registerField, value]);

  useEffect(() => {
    if (setState) setState(value);
  }, [value, setState]);

  return (
    <Container>
      <InputLabel>{label}</InputLabel>

      <StyledAutocomplete
        onFocus={clearError}
        value={value}
        onChange={(event, text) => setValue(text)}
        options={data}
        getOptionLabel={getOptionLabel}
        size="small"
        noOptionsText="Sem opções"
        fullWidth
        renderInput={(params) => (
          <StyledTextField
            id={fieldName}
            inputRef={inputRef}
            defaultValue={defaultValue}
            variant="outlined"
            error={error !== undefined}
            helperText={error}
            {...params}
            {...rest}
          />
        )}
      />
    </Container>
  );
}

AutocompleteComponent.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  setState: PropTypes.func,
  state: PropTypes.shape([PropTypes.object, PropTypes.string]),
  getOptionLabel: PropTypes.func.isRequired,
};

AutocompleteComponent.defaultProps = {
  state: null,
  setState: null,
};

export default AutocompleteComponent;
